export enum ActualsValueTypes {
  None = '',
  UTNet = 'UTNet',
  TNet = 'TNet',
  Net = 'Net',
  Ndp = 'Ndp',
}

// Default values types

// Reseller
export const DEFAULT_NETNDP = ActualsValueTypes.UTNet
export const DEFAULT_NETNDP_TYPES = [ActualsValueTypes.Net, ActualsValueTypes.Ndp]

// Partner User
export const DEFAULT_NETNDP_PARTNER_USER = ActualsValueTypes.Ndp
export const DEFAULT_NETNDP_PARTNER_USER_TYPES = [DEFAULT_NETNDP_PARTNER_USER]

// Retail
export const DEFAULT_NETNDP_RETAIL = ActualsValueTypes.TNet

// QBR
export const DEFAULT_NETNDP_QBR = ActualsValueTypes.Ndp

// Distributor
export const DEFAULT_NETNDP_DISTRIBUTOR = ActualsValueTypes.TNet
export const DEFAULT_NETNDP_DISTRIBUTOR_TYPES = [
  ActualsValueTypes.TNet,
  ActualsValueTypes.Net,
  ActualsValueTypes.Ndp,
]
